module.exports = __webpack_public_path__ + "img/010-startup.67625f6c.svg";